import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const RESOURCES_SERVICE_AUTHORIZATION = {
  authorized: {
    labelText: 'Acessar portal',
    rowColor: NEW_COLORS.PRIMARY[500],
    cursor: 'pointer',
    title: '',
  },
  unauthorized: {
    labelText: 'Não autorizado',
    rowColor: NEW_COLORS.GRAYSCALE[300],
    cursor: 'not-allowed',
    title:
      'Você não possui permissão para acessar este serviço. Entre em contato com o beneficiário para orientá-lo a aceitar o termo de consentimento via portal do beneficiário.',
  },
};
